
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ButtonContact from '@/components/ButtonContact.vue';


@Component({
    components: {
        ButtonContact
    }
})
export default class TheHomePageHeroSection extends Vue {
    contactOnClick() {
        console.log('contact button test');
        alert('redirecting you to contact section...');
    }
}
